import styled, { css } from 'styled-components';
import Bill from 'components/Bill';
import profileImg from '../assets/profile.png';
import { PaymentInfo } from 'baseTypes';
import { PlacingPaymentConsumer } from 'contexts/placingPayment';
import TipForm from 'pages/Payments/pages/TipForm';
import Icon, { Icons } from 'components/Icon';
import BuyerEmailInput from 'components/BuyerEmailInput';

const Wrapper = styled.div`
  max-width: 100%;
  margin: 0 auto;
  padding: 0 20px;

  @media (min-width: 768px) {
    max-width: 75%;
    padding: 0;
  }

  ${({ theme: { mui } }) => css`
    ${mui.breakpoints.up('xl')} {
      max-width: none;
      margin: initial;
    }
  `};
`;

const BillCard = styled.div`
  background: rgba(255, 255, 255, 0.65);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.8);
  border-radius: 20px;
  padding: 20px 20px 16px;
  margin-top: 16px;
  box-shadow:
    0 4px 24px rgba(15, 23, 42, 0.04),
    0 1px 3px rgba(15, 23, 42, 0.03);
  position: relative;
  overflow: hidden;

`;

const PaymentTipsContainer = styled.div`
  margin-top: 16px;
`;


const IconWrapper = styled.div`
  display: none;
`;


type TotalBillProps = {
  paymentInfo: PaymentInfo;
};

const TotalBill = ({ paymentInfo }: TotalBillProps) => {
  const { logoImage, companyName, amount, payload, taxAmount, type, fullAmount, extraFee } =
    paymentInfo;
  const merchant = {
    companyName: companyName,
    logoImage: logoImage || profileImg,
  };

  return (
    <PlacingPaymentConsumer>
      {({ paymentInfo }) => {
        const { isShowTip } = paymentInfo;
        return (
          <Wrapper>
            <IconWrapper>
              <Icon name={Icons.Logo} />
            </IconWrapper>
            <BillCard>
              <Bill
                merchant={merchant}
                total={amount}
                type={type}
                totalTax={Number(taxAmount)}
                menuItems={payload || []}
                fullAmount={fullAmount}
                extraFee={extraFee}
              />
              {isShowTip && (
                <PaymentTipsContainer>
                  <TipForm />
                </PaymentTipsContainer>
              )}
              <BuyerEmailInput />
            </BillCard>
          </Wrapper>
        );
      }}
    </PlacingPaymentConsumer>
  );
};
export default TotalBill;
